/* eslint-disable no-unused-vars */

import { CaptionText, H3, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import {
  Flexed,
  ProgressBar,
  ProgressBarWithPercentage
} from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';

import moment from 'moment';
import {
  formatUSD,
  formatUSDNoDecimals,
  ULX,
  USDT
} from '../../../helpers/helperFunctions';
import { Flex, Responsive } from '../../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';
import { PackageTrading, UserPackage } from '../Portfolio.types';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { Button } from '../../../components';
import { Link } from 'react-router-dom';
import { MANAGE_AKASHA_NODE } from '../../../routes/routes';

import {
  Desktop,
  Mobile
} from '../../MyTeamBackoffice/Structure/common/UserVerifications/UserVerification.styles';
import { ConnectWalletStatus } from '../../FlipMeWallet/FlipMeBanner';
import { RedeemFlipmeCardsStepsEnum } from '../RedeemFlipmeCards/types';
import { useAppSelector } from '../../../app/hooks';
import { RedeemFlipmeCards } from '../RedeemFlipmeCards/RedeemFlipmeCards';

export const PortfolioPowerPacksItem = ({
  item,
  setIsOpen,
  setPackageItem
}: {
  item: PackageTrading;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setPackageItem: Dispatch<SetStateAction<UserPackage | PackageTrading | null>>;
}) => {
  const { t } = useTranslation('my_hubs');

  const [redeemCardsModal, setRedeemCardsModal] = useState(false);

  const [redeemFlipmeCardsStep, setRedeemFlipmeCardsStep] =
    useState<RedeemFlipmeCardsStepsEnum>(RedeemFlipmeCardsStepsEnum.STEP1);

  const getDepositPercentage = (
    depositedAmount: number | null | undefined,
    depositLimit: number | null | undefined
  ) => {
    if (!depositedAmount || !depositLimit) {
      return 0;
    } else {
      return Math.round((depositedAmount / depositLimit) * 100);
    }
  };

  const { flipMeStatus, isPersonalFlipmeRedeemRequired } = useAppSelector(
    (state) => state.wallets
  );

  return (
    <>
      <BoxBig relative>
        <HubImage image={item.image}>
          <H4 color={color.colors.neutral0}></H4>
        </HubImage>
        <Flexed column between>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ marginBottom: '20px' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {item.price} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('order_id')}:
                </CaptionText>
                <P1 bold>{item?.id}</P1>
              </Td>

              {/* <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('nft_id')}:
                </CaptionText>
                <P1 bold>{item?.nftId}</P1>
              </Td> */}
              {/* 
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Status
                </CaptionText>
                <Flexed center>
                  <P3 bold caps>
                    {item?.isActive ? t('active') : t('inactive')}
                  </P3>
                  <Circle
                    color={
                      item?.isActive
                        ? color.colors.success500
                        : color.colors.error500
                    }
                  />
                </Flexed>
              </Td> */}
              {/* <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  amount minted:
                </CaptionText>
                <P1 bold>
                  {' '}
                  {formatUSD(item?.mintedAmount || 0)} {ULX}
                </P1>
              </Td> */}
            </Tr>
          </div>

          {/* <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                amount minted
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(item?.mintedAmount || 0)} {item?.mintedTokenCurrency}
              </P1>
            </Td>
          </Tr> */}

          <Tr style={{ marginBottom: '20px' }}>
            <Td w='30%' wSM='100%'>
              <H3>SuperNode</H3>
            </Td>
            <Td w='20%' wSM='50%'>
              <P1 color={color.colors.primary900}>
                VALUE:{' '}
                <b>
                  {formatUSDNoDecimals(
                    item?.details?.items?.superNode?.price || 0
                  )}{' '}
                  {USDT}
                </b>
              </P1>
            </Td>
            <Td w='25%' wSM='50%'>
              <P1 color={color.colors.primary900}>
                NFT ID: <b>{item?.nftId}</b>
              </P1>
            </Td>
            <Td w='25%' wSM='100%'>
              <Flexed end width='100%' widthSM='100%'>
                <Link to={`${MANAGE_AKASHA_NODE}/${item.id}`}>
                  <Button
                    condensed
                    mt='20'
                    w='135px'
                    p='0 16px'
                    disabled={
                      !item?.nftId || item?.depositedTokenCurrency === 'AK1111'
                    }>
                    Manage
                  </Button>
                </Link>
              </Flexed>
            </Td>
          </Tr>

          <Flexed rowSM gap='50px' gapSM='20px' mb='20'>
            <Flexed column width='50%' widthSM='100%'>
              <Flexed between center>
                <Desktop style={{ width: '100%' }}>
                  <Flexed between center>
                    <Flexed center gap='5px'>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        DEPOSITED
                      </CaptionText>

                      <P2 semiBold>
                        {item?.depositedUsdtAmount
                          ? formatUSD(item?.depositedUsdtAmount)
                          : 0}{' '}
                        {USDT} / {formatUSD(item?.depositedCurrencyAmount)}{' '}
                        {ULX}
                      </P2>
                    </Flexed>

                    <Flexed center gap='5px'>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        Max deposit
                      </CaptionText>

                      <P2 semiBold>
                        {' '}
                        {item?.depositLimit ? formatUSD(item?.depositLimit) : 0}
                      </P2>
                    </Flexed>
                  </Flexed>
                </Desktop>
                <Mobile style={{ width: '100%' }}>
                  <Flexed between>
                    <Flexed column>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        DEPOSITED
                      </CaptionText>

                      <P2 semiBold>
                        {item?.depositedUsdtAmount
                          ? formatUSD(item?.depositedUsdtAmount)
                          : 0}{' '}
                        {USDT} / {formatUSD(item?.depositedCurrencyAmount)}{' '}
                        {item?.depositedTokenCurrency}
                      </P2>
                    </Flexed>

                    <Flexed column>
                      <CaptionText caps bold color={color.colors.neutral500}>
                        Max deposit
                      </CaptionText>

                      <P2 semiBold>
                        {' '}
                        {item?.depositLimit ? formatUSD(item?.depositLimit) : 0}
                      </P2>
                    </Flexed>
                  </Flexed>
                </Mobile>
              </Flexed>

              <ProgressBar
                percentage={`${getDepositPercentage(
                  item?.depositedUsdtAmount,
                  item?.depositLimit
                )}%`}
                percentageLabel
                progressColor={'#25E8BA'}>
                <div></div>
                <span>
                  {' '}
                  {getDepositPercentage(
                    item?.depositedUsdtAmount,
                    item?.depositLimit
                  )}
                  %
                </span>
              </ProgressBar>
            </Flexed>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                amount minted:
              </CaptionText>
              <P1 bold>
                {' '}
                {formatUSD(item?.mintedAmount || 0)} {ULX}
              </P1>
            </Td>
          </Flexed>

          <Tr style={{ marginBottom: '20px' }}>
            <Td w='30%' wSM='100%'>
              <H3>
                Flipme {item?.price === 5000 ? 'Physical' : 'Virtual'} Card
              </H3>
            </Td>
            <Td w='20%' wSM='50%'>
              <P1 color={color.colors.primary900}>
                VALUE:{' '}
                <b>
                  {formatUSDNoDecimals(
                    item?.details?.items?.flipme?.price || 0
                  )}{' '}
                  {USDT}
                </b>
              </P1>
            </Td>

            {item?.price !== 5000 && (
              <Td w='50%' wSM='50%'>
                <Flexed end width='100%' widthSM='100%'>
                  <Button
                    condensed
                    mt='20'
                    w='auto'
                    p='0 16px'
                    disabled={item?.flipmeCardsRemaining === 0}
                    onClick={() => {
                      if (flipMeStatus !== ConnectWalletStatus.CONNECTED) {
                        setIsOpen(true);
                      } else if (isPersonalFlipmeRedeemRequired) {
                        setRedeemCardsModal(true);
                        setRedeemFlipmeCardsStep(
                          RedeemFlipmeCardsStepsEnum.STEP1
                        );
                        setPackageItem(item);
                      } else {
                        setRedeemCardsModal(true);
                        setRedeemFlipmeCardsStep(
                          RedeemFlipmeCardsStepsEnum.STEP2
                        );
                        setPackageItem(item);
                      }
                    }}>
                    Activate Card
                  </Button>
                </Flexed>
              </Td>
            )}
          </Tr>

          {item?.details?.items?.finup !== null && (
            <Tr>
              <Td w='30%' wSM='100%'>
                <H3>FinUp Membership</H3>
              </Td>
              <Td w='20%' wSM='50%'>
                <P1 color={color.colors.primary900}>
                  VALUE:{' '}
                  <b>
                    {formatUSDNoDecimals(
                      item?.details?.items?.finup?.price || 0
                    )}{' '}
                    {USDT}
                  </b>
                </P1>
              </Td>
              <Td w='25%' wSM='50%'>
                <P1 color={color.colors.primary900}>
                  From:{' '}
                  <b> {moment(item?.dateOfPurchase).format('DD. MMMM YYYY')}</b>
                </P1>
              </Td>
              <Td w='25%' wSM='50%'>
                <P1 color={color.colors.primary900}>
                  To:{' '}
                  <b>
                    {' '}
                    {item?.price === 5000
                      ? moment(item?.dateOfPurchase)
                          .add(2, 'year')
                          .format('DD. MMMM YYYY')
                      : moment(item?.dateOfPurchase)
                          .add(1, 'year')
                          .format('DD. MMMM YYYY')}
                  </b>
                </P1>
              </Td>
            </Tr>
          )}
        </Flexed>
      </BoxBig>
      <RedeemFlipmeCards
        redeemCardsModal={redeemCardsModal}
        setRedeemCardsModal={setRedeemCardsModal}
        redeemFlipmeCardsStep={redeemFlipmeCardsStep}
        setRedeemFlipmeCardsStep={setRedeemFlipmeCardsStep}
        packageId={item?.id}
      />
    </>
  );
};
